import useListOneLogsData from './useListOneLogsData';
import useListTwoLogsData from './useListTwoLogsData';

export { useListOneLogsData, useListTwoLogsData };
